import {useLocation} from '@github-ui/react-router'
import {useMemo} from 'react'

export function useIsSharedThread() {
  const location = useLocation()
  const pathname = location.pathname

  return useMemo(() => {
    return pathname.includes('/share/')
  }, [pathname])
}
